import {
  Form,
  Select,
  DatePicker,
  Button,
  Modal,
  Row,
  Col,
  Divider,
  Grid,
  message,
  Space,
  Input,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { TaskProps } from "../../interfaces/interfaces";
import DataContext from "../../context/DataContext";
import { TASK_INITIAL_STATE } from "../../utils/data";
import dayjs from "dayjs";
import { TagSelector } from "../ui";
import { filterOption } from "../../utils/func/utils";
import TextArea from "antd/es/input/TextArea";
import {
  GooglePlusOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";

// const frequency_map: {
//   [key: string]: number;
// } = {
//   Daily: 1,
//   Weekly: 7,
//   Monthly: 30,
//   Yearly: 365,
// };

interface Props {
  modalStatus: {
    open: boolean;
    create: boolean;
    update: boolean;
    payload?: TaskProps | null;
  } | null;
  idClient?: string;
  onCancel: () => void;
  onSubmit: (values: TaskProps) => void;
  allowCreateInGoogle?: boolean;
}

export const ModalCreateOrUpdateTask = ({
  modalStatus,
  idClient,
  onCancel,
  onSubmit,
  allowCreateInGoogle = false,
}: Props) => {
  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();
  const [form] = Form.useForm();
  const [values, setValues] = useState<TaskProps>(TASK_INITIAL_STATE);
  const [isLoading, setIsLoading] = useState(false);
  const [projectOptions, setProjectOptions] = useState<any[]>([]);
  const [isMultipleCustomers, setisMultipleCustomers] =
    useState<boolean>(false);
  const [showEventDetails, setShowEventDetails] = useState<boolean>(false);
  const {
    usersList,
    userOptions,
    customerOptions,
    customerByClient,
    contactList,
    projectList,
    getData,
  } = useContext(DataContext);
  useEffect(() => {
    if (values) {
      form.setFieldsValue(values);
    } else {
      form.setFieldsValue(TASK_INITIAL_STATE);
      setValues(TASK_INITIAL_STATE);
    }
  }, [values]);

  useEffect(() => {
    if (modalStatus && modalStatus.payload) {
      setValues(modalStatus.payload);
    } else {
      setValues(TASK_INITIAL_STATE);
    }
  }, [modalStatus]);

  useEffect(() => {
    if (idClient) {
      const filters = values.customer?.hasOwnProperty("_id")
        ? values.customer?._id
        : values.customer;
      getData("contacts", idClient, undefined, {
        customers: filters,
      });
    }
  }, [idClient, values.customer]);

  useEffect(() => {
    setisMultipleCustomers(
      Boolean(
        (modalStatus?.payload?.customers &&
          Array.isArray(modalStatus?.payload?.customers) &&
          modalStatus?.payload?.customers?.length > 0) ||
          modalStatus?.payload?.customers?.length === 0,
      ),
    );
  }, [modalStatus?.payload?.customers]);

  useEffect(() => {
    if (customerByClient) {
      let customerProjects = customerByClient.find(
        (customer) =>
          customer._id ===
          (typeof values.customer === "object" && values.customer !== null
            ? values.customer._id
            : values.customer),
      )?.Projects;
      if (customerProjects) {
        setProjectOptions(customerProjects);
        const projectId =
          typeof values.project === "object" && values.project !== null
            ? values.project._id
            : values.project;
        const foundProject =
          customerProjects.find((p) => p.id._id === projectId)?.id || null;
        setValues((prev) => ({
          ...prev,
          project: foundProject,
        }));
      } else {
        setProjectOptions([]);
      }
    }
  }, [customerByClient, values.customer, values.project]);

  return (
    <Modal
      title="Task"
      destroyOnClose
      open={modalStatus?.open || false}
      width={1000}
      zIndex={2000}
      onOk={onCancel}
      onCancel={() => {
        onCancel();
        form.resetFields();
        setValues(TASK_INITIAL_STATE);
      }}
      footer={null}
      centered
    >
      <Form layout="vertical" form={form} initialValues={values}>
        <Row gutter={16}>
          <Col lg={8} md={12} sm={12} xs={12}>
            <Form.Item label="Customer">
              {isMultipleCustomers ? (
                <Select
                  allowClear
                  showSearch
                  maxTagCount="responsive"
                  mode={"multiple"}
                  optionFilterProp="children"
                  filterOption={filterOption}
                  options={
                    values?.customers?.map((customer) => ({
                      label: customer.DisplayName || "",
                      value: customer._id,
                    })) || customerOptions
                  }
                  placeholder={"Select Customer"}
                  value={values.customers?.map((customer) => customer._id)}
                  onChange={(value) => {
                    if (!value) {
                      setValues({
                        ...values,
                        customers: [],
                        customer: null,
                      });
                    } else {
                      setValues({
                        ...values,
                        customers: value as any,
                      });
                    }
                  }}
                />
              ) : (
                <Select
                  allowClear
                  showSearch
                  maxTagCount="responsive"
                  optionFilterProp="children"
                  filterOption={filterOption}
                  options={
                    values?.customers?.map((customer) => ({
                      label: customer.DisplayName || "",
                      value: customer._id,
                    })) || customerOptions
                  }
                  placeholder={"Select Customer"}
                  value={
                    values.customer?.hasOwnProperty("_id")
                      ? values.customer._id
                      : values.customer
                  }
                  onChange={(value) => {
                    if (!value) {
                      setValues({
                        ...values,
                        customer: value as any,
                      });
                    } else {
                      setValues({
                        ...values,
                        customer: value as any,
                      });
                    }
                  }}
                />
              )}
            </Form.Item>
          </Col>

          <Col lg={8} md={12} sm={12} xs={12}>
            <Form.Item label="Project">
              <Select
                showSearch
                allowClear
                placeholder="Select project"
                options={
                  isMultipleCustomers || !values.customer
                    ? projectList.map((p) => ({ label: p.name, value: p._id }))
                    : projectOptions.map((p) => ({
                        label: p.id?.name,
                        value: p.id?._id,
                      }))
                }
                value={values.project?._id || values.project}
                disabled={!values.customer || isMultipleCustomers}
                filterOption={filterOption}
                onChange={(value) => {
                  if (!value) {
                    setValues({
                      ...values,
                      project: value as any,
                    });
                  } else {
                    const selectedProject = projectOptions.find(
                      (p) => p.id._id === value,
                    );
                    setValues({
                      ...values,
                      project: selectedProject?.id || null,
                    });
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col lg={8} md={12} sm={12} xs={12}>
            <Form.Item label="Contact">
              <Select
                allowClear
                showSearch
                disabled={isMultipleCustomers}
                optionFilterProp="children"
                filterOption={filterOption}
                options={
                  values.customer
                    ? contactList.map((contact) => ({
                        label: contact.name || "",
                        value: contact._id,
                      }))
                    : []
                }
                placeholder="Select Contact"
                value={values.relatedContact?._id}
                onChange={(value) => {
                  if (!value) {
                    setValues({
                      ...values,
                      relatedContact: undefined,
                    });
                  } else {
                    setValues({
                      ...values,
                      relatedContact: value as any,
                    });
                  }
                }}
              />
            </Form.Item>
          </Col>
          {/* Type of Task */}
          <Col lg={6} md={12} sm={12} xs={12}>
            <Form.Item
              label="Type of Task"
              name="typeOfTask"
              rules={[{ required: true }]}
            >
              <Select
                filterOption={filterOption}
                placeholder="Select task type"
                onChange={(value) =>
                  setValues({ ...values, typeOfTask: value })
                }
                showSearch
                options={[
                  { label: "Call", value: "Call" },
                  { label: "Meeting", value: "Meeting" },
                  { label: "Follow-up", value: "Follow-up" },
                  { label: "Email", value: "Email" },
                  { label: "To do ", value: "To do" },
                  { label: "Other", value: "Other" },
                ]}
              />
            </Form.Item>
          </Col>
          {/* Priority */}
          <Col lg={6} md={12} sm={12} xs={12}>
            <Form.Item label="Priority" name="priority">
              <Select
                filterOption={filterOption}
                showSearch
                placeholder="Select priority"
                onChange={(value) => setValues({ ...values, priority: value })}
                options={[
                  { label: "Low", value: "Low" },
                  { label: "Medium", value: "Medium" },
                  { label: "High", value: "High" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={12} xs={12}>
            <Form.Item label="Tags">
              <TagSelector
                selectedTags={values.tags || []}
                setSelectedTags={(selectedTags) => {
                  setValues({ ...values, tags: selectedTags });
                }}
              />
            </Form.Item>
          </Col>

          {/* Status */}
          <Col lg={6} md={12} sm={12} xs={12}>
            <Form.Item
              label="Status"
              name="status"
              rules={[{ required: true }]}
            >
              <Select
                filterOption={filterOption}
                showSearch
                placeholder="Select status"
                onChange={(value) => setValues({ ...values, status: value })}
                options={[
                  { label: "Pending", value: "Pending" },
                  { label: "In Progress", value: "In Progress" },
                  { label: "Completed", value: "Completed" },
                  { label: "Cancelled", value: "Cancelled" },
                ]}
              />
            </Form.Item>
          </Col>
          {/* Assigned To */}
          <Col lg={6} md={12} sm={12} xs={12}>
            <Form.Item label="Assigned To">
              <Select
                filterOption={filterOption}
                showSearch
                maxTagCount="responsive"
                mode="multiple"
                value={
                  Array.isArray(values.assignedTo)
                    ? values.assignedTo.map((user) => user._id)
                    : values.assignedTo?._id
                      ? [values.assignedTo?._id]
                      : null
                }
                placeholder="Assign to user"
                options={userOptions}
                onChange={(value) => {
                  const selected = usersList.filter((user) =>
                    value.includes(user._id as any),
                  );
                  setValues({ ...values, assignedTo: selected });
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          {/* Start Date */}
          <Col lg={6} md={12} sm={12} xs={12}>
            <Form.Item label="Task Date">
              <DatePicker
                popupStyle={{
                  position: "fixed",
                  top: xs ? 50 : "40vh",
                  left: xs ? 20 : "50vw",
                }}
                value={values.startDate && dayjs(values.startDate)}
                showTime={{
                  format: "HH:mm",
                  defaultValue: dayjs("08:00", "HH:mm"),
                  minuteStep: 5,
                  // Use 24-hour format and show as a single input
                  showNow: true,
                }}
                format="MM/DD/YYYY HH:mm"
                style={{ width: "100%" }}
                onChange={(value) => {
                  if (!value) {
                    setValues({
                      ...values,
                      startDate: value,
                      nextDate: null,
                      isRecurring: false,
                      frequency: "Daily",
                      endDate: null,
                    });
                  } else {
                    const startDate = value;
                    const endDate = value
                      ? dayjs(value).add(30, "minute")
                      : null;
                    setValues({ ...values, startDate, endDate });
                  }
                }}
                inputReadOnly={false}
                allowClear
                placeholder="Select date and time"
              />
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={12} xs={12}>
            <Form.Item label="End Date">
              <DatePicker
                popupStyle={{
                  position: "fixed",
                  top: xs ? 50 : "40vh",
                  left: xs ? 20 : "50vw",
                }}
                value={values.endDate && dayjs(values.endDate)}
                showTime={{
                  format: "HH:mm",
                  defaultValue: dayjs("08:00", "HH:mm"),
                  minuteStep: 5,
                  // Use 24-hour format and show as a single input
                  showNow: true,
                }}
                format="MM/DD/YYYY HH:mm"
                style={{ width: "100%" }}
                onChange={(value) => {
                  if (!value) {
                    setValues((prev) => ({
                      ...prev,
                      endDate: null,
                    }));
                  } else {
                    setValues((prev) => ({ ...prev, endDate: value }));
                  }
                }}
              />
            </Form.Item>
          </Col>
          {/* End Date */}
          <Col
            lg={6}
            md={2}
            sm={2}
            xs={2}
            style={{
              alignContent: "center",
              alignItems: "center",
              justifyItems: "center",
              textAlign: "center",
            }}
          >
            {values.origin !== "project-template" && (
              <Form.Item
                label="Add to Google Calendar"
                name="createInGoogleCalendar"
              >
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Select
                    value={values.createInGoogleCalendar ? "yes" : "no"}
                    style={{ width: 100 }}
                    disabled={
                      !values.startDate ||
                      modalStatus?.update ||
                      !values.assignedTo
                    }
                    onChange={(value) =>
                      setValues({
                        ...values,
                        createInGoogleCalendar: value === "yes",
                      })
                    }
                    options={[
                      { label: "Yes", value: "yes" },
                      { label: "No", value: "no" },
                    ]}
                  />
                  <img
                    src="https://www.gstatic.com/images/branding/product/2x/calendar_48dp.png"
                    alt="Google Calendar"
                    style={{ width: 32, height: 32 }}
                  />
                </div>
              </Form.Item>
            )}
          </Col>
          {modalStatus?.create && values.origin !== "project-template" && (
            <Col lg={24} md={24} xs={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Button
                  type="link"
                  icon={showEventDetails ? <UpOutlined /> : <DownOutlined />}
                  onClick={() => setShowEventDetails((prev) => !prev)}
                  style={{ padding: 0 }}
                >
                  {showEventDetails
                    ? "Hide Event Details"
                    : "Show Event Details"}
                </Button>
              </div>
              {showEventDetails && (
                <Row justify="end" gutter={0}>
                  <Col span={24}>
                    <Form.Item label="Event Description">
                      <Input
                        value={
                          values.createInGoogleCalendar ? values.typeOfTask : ""
                        }
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Event Title">
                      <Input.TextArea
                        value={
                          values.createInGoogleCalendar
                            ? values.description + " - " + values.notes
                            : ""
                        }
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </Col>
          )}

          <Col span={24}>
            <Divider style={{ margin: "16px 0" }} />
          </Col>
          {/* Description */}
          <Col lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true, message: "Description is required" }]}
            >
              <TextArea
                value={values.description}
                placeholder="Enter description"
                rows={3}
                onChange={(e) =>
                  setValues({ ...values, description: e.target.value })
                }
              />
            </Form.Item>
          </Col>
          {/* Repeat Task & Frequency */}
          {/* <Col span={4}>
            <Form.Item name="isRecurring" valuePropName="checked" label=" ">
              <Checkbox
                disabled={!values.startDate}
                onChange={(e) => {
                  if (e.target.checked) {
                    const frequency =
                      frequency_map[values.frequency || "Daily"];
                    const startDate = dayjs(values.startDate);
                    let nextDate = null;
                    if (startDate) {
                      nextDate = startDate?.add(frequency, "days");
                    }
                    setValues({
                      ...values,
                      isRecurring: e.target.checked,
                      nextDate,
                    });
                  } else {
                    setValues({
                      ...values,
                      isRecurring: e.target.checked,
                      nextDate: null,
                    });
                  }
                }}
              >
                Set To Repeat
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Frequency" name="frequency">
              <Select
                filterOption={filterOption}
                showSearch
                placeholder="Select frequency"
                disabled={!values.isRecurring}
                onChange={(value) => {
                  const frequency = frequency_map[value];
                  const startDate = values.startDate;
                  const nextDate = startDate?.add(frequency, "days");
                  setValues({ ...values, nextDate, frequency: value });
                }}
                options={[
                  { label: "Daily", value: "Daily" },
                  { label: "Weekly", value: "Weekly" },
                  { label: "Monthly", value: "Monthly" },
                  { label: "Yearly", value: "Yearly" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Next Date">
              <DatePicker
                popupStyle={{ position: "fixed", top: 250, left: 450 }}
                showTime
                style={{ width: "100%" }}
                value={values.nextDate && dayjs(values.nextDate)}
                disabled={!values.isRecurring}
                format="MM/DD/YYYY HH:mm"
                onChange={(value, dateString) => {
                  console.log("Selected Time: ", value);
                  console.log("Formatted Selected Time: ", dateString);
                }}
              />
            </Form.Item>
          </Col> */}

          {/* Notes (Full Width) */}
          <Col lg={12} md={12} sm={24} xs={24}>
            <Form.Item label="Notes/Follow-up" name="notes">
              <TextArea
                placeholder="Enter additional details"
                rows={3}
                onChange={(e) =>
                  setValues({ ...values, notes: e.target.value })
                }
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Buttons */}
        <Row justify="end" style={{ marginTop: 16 }}>
          <Space direction="vertical" size={0} style={{ textAlign: "right" }}>
            <Space direction="horizontal">
              <Button type="default" onClick={onCancel}>
                Cancel
              </Button>
              {modalStatus?.create && allowCreateInGoogle ? (
                <Button
                  style={{ marginLeft: 8, backgroundColor: "#2684fc" }}
                  type="primary"
                  icon={<GooglePlusOutlined />}
                  onClick={() => {
                    form
                      .validateFields()
                      .then(() => {
                        if (isLoading) return; // Prevent duplicate submissions
                        setIsLoading(true);
                        onSubmit({
                          ...modalStatus?.payload,
                          ...values,
                          createInGoogleTasks: true,
                        });
                        setTimeout(() => {
                          setIsLoading(false);
                        }, 1000);
                      })
                      .catch((error) => {
                        message.error("Please fill all required fields.");
                      });
                  }}
                >
                  Google/CRM{" "}
                </Button>
              ) : null}
              <Button
                type="primary"
                style={{ marginLeft: 8 }}
                disabled={isLoading}
                loading={isLoading}
                onClick={() => {
                  form
                    .validateFields()
                    .then(() => {
                      if (isLoading) return; // Prevent duplicate submissions
                      setIsLoading(true);
                      onSubmit({
                        ...modalStatus?.payload,
                        ...values,
                        createInGoogleTasks: false,
                      });
                      setTimeout(() => {
                        setIsLoading(false);
                      }, 1000);
                    })
                    .catch((error) => {
                      message.error("Please fill all required fields.");
                    });
                }}
              >
                {modalStatus?.create ? "CRM" : "Edit Task"}
              </Button>
            </Space>
          </Space>
        </Row>
      </Form>
    </Modal>
  );
};
